import { useTranslation } from 'react-i18next'

import { toaster as rawToaster } from '@enechain/ecloud-designsystem'

import {
  type CsvColumnDef,
  csvFileName,
  downloadCsv,
} from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

// GenerationSalesPlanList/index.tsx と同じ toaster 型 narrowing パターン
// (= ecloud `toaster.create` の型が広すぎるため、使用する引数のみに絞る)。
type AppToaster = {
  create: (options: { type?: 'error'; title?: string }) => string
}
const toaster = rawToaster as unknown as AppToaster

/**
 * 広域マスタ CSV エクスポート共通ハンドラ (spec AC-012 / AC-012b)。
 *
 * 各タブの List RPC 取得済みデータ (= 現在のフィルタ適用後の表示行、design
 * doc §4「実行場所」決定によりフロントエンド側でフィルタ済みデータから
 * 生成する) とタブ固有カラム定義から CSV を生成しダウンロードする
 * (`downloadCsv`)。 生成/ダウンロード失敗時は共通エラーメッセージを toast
 * 表示する (AC-03)。
 */
export function useCsvExportHandler<T>(
  rows: readonly T[],
  columnDefs: ReadonlyArray<CsvColumnDef<T>>,
  tabKey: string,
): () => void {
  const { t } = useTranslation()
  return () => {
    downloadCsv(rows, columnDefs, csvFileName(tabKey), () => {
      toaster.create({
        type: 'error',
        title: t('page:adminOcctoMaster.toolbar.csvExportError'),
      })
    })
  }
}
